import { getEmployeeProfiles } from '@api/company-policy';
import { useQuery } from '@tanstack/react-query';

export const useGetEmployeeProfiles = () => {
  const {
    data: employeeProfiles = [],
    isFetching,
    refetch: refetchEmployeeProfiles,
  } = useQuery({
    queryFn: () => getEmployeeProfiles(),
    queryKey: ['employee-profiles'],
  });

  const employeeProfilesOptions = employeeProfiles.map((employeeProfile) => ({
    isDefault: employeeProfile.isDefault,
    variant: employeeProfile.color,
    label: employeeProfile.name,
    value: employeeProfile.id,
  }));

  const getEmployeeProfileName = (id: string) => {
    return employeeProfiles.find((employeeProfile) => employeeProfile.id === id)?.name;
  };

  return {
    employeeProfilesOptions,
    employeeProfiles,
    isFetching,
    refetchEmployeeProfiles,
    getEmployeeProfileName,
  };
};
